import { render, staticRenderFns } from "./LoginOptionMenu.vue?vue&type=template&id=afe70276&scoped=true"
import script from "./LoginOptionMenu.vue?vue&type=script&lang=js"
export * from "./LoginOptionMenu.vue?vue&type=script&lang=js"
import style0 from "./LoginOptionMenu.vue?vue&type=style&index=0&id=afe70276&prod&lang=css"
import style1 from "./LoginOptionMenu.vue?vue&type=style&index=1&id=afe70276&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "afe70276",
  null
  
)

export default component.exports